module.exports = __webpack_public_path__ + "img/circle-heart.7cea0122.svg";